import React from 'react';

import { makeStyles } from 'tss-react/mui';
import Button from '@mui/material/Button';
import { units } from '@hbf/dsl';

import { Page } from './types';

interface Props {
  page: Page;
  getPageHref: (p: number) => string;
  onPageChange: (p: Page) => void;
  children?: React.ReactNode;
  variant?: 'text' | 'outlined';
}

const useStyles = makeStyles()({
  button: {
    margin: units.rem(0.2),
    padding: units.rem(0.2),
    minWidth: units.rem(2),
  },
});

export const PagerButton: React.FC<Props> = ({
  children = null,
  page,
  getPageHref,
  onPageChange,
  variant = 'outlined',
  ...rest
}) => {
  const { classes } = useStyles();

  const handlePageChange = React.useCallback<
    React.MouseEventHandler<HTMLElement>
  >(
    event => {
      event.preventDefault();

      onPageChange(page);
    },
    [onPageChange, page],
  );

  return (
    <Button
      className={classes.button}
      size="small"
      variant={page.active ? 'contained' : variant}
      color={page.active ? 'primary' : undefined}
      component="a"
      href={getPageHref(page.num)}
      onClick={handlePageChange}
      data-test-locator={page.active ? 'Current Page Button' : 'Page Button'}
      {...rest}
    >
      {children || page.num}
    </Button>
  );
};
